import logger from "../helpers/logger";
import { getCookieValue, removeCookie } from "./context/cookies";
import { IDENTITY_SDK_RESET_COOKIE } from "./constants";
import {
  setLoggedInState,
  setUserProfile,
  setUserFetchingState,
  setUserReconsentStatus,
  SUCCESS,
  FETCHING,
  FAILED
} from "../template/state/modules/user";
import { stripSubdomain } from "../helpers/url";
import { asosGlobalNamespace, sdkGlobalNamespace } from "../template/constants";

const fetchUserProfile = store => {
  const sdkNamespace = window[asosGlobalNamespace][sdkGlobalNamespace];

  if (!sdkNamespace.identity) return;

  const { identity: identitySDK } = sdkNamespace;

  if (getCookieValue(IDENTITY_SDK_RESET_COOKIE) === "true") {
    const domain = `.${stripSubdomain(window.location.hostname)}`;

    identitySDK.customer.resetLocalCopy();
    removeCookie(IDENTITY_SDK_RESET_COOKIE, domain);
  }

  store.dispatch(setUserFetchingState(FETCHING));

  return identitySDK.customer
    .profile()
    .then(profile => {
      if (!profile) {
        throw new Error("Empty profile");
      }

      const { isAuthenticated, customerId, firstTimeBuyer } = profile;

      window.asos.eventBus.emit("signal.profile.ready", {
        isAuthenticated,
        customerId,
        firstTimeBuyer
      });

      store.dispatch(setUserProfile(profile));
      store.dispatch(setLoggedInState(profile.isAuthenticated));
      store.dispatch(setUserFetchingState(SUCCESS));

      if (profile.isAuthenticated || profile.isRecognised) {
        return identitySDK.customer
          .isReconsentRequired()
          .then(reconsentRequired =>
            store.dispatch(setUserReconsentStatus(reconsentRequired))
          )
          .catch(logger.warn);
      }
    })
    .catch(() => {
      store.dispatch(setUserFetchingState(FAILED));
    });
};

export default store => {
  if (window[asosGlobalNamespace][sdkGlobalNamespace].identity)
    return fetchUserProfile(store);
  return window[asosGlobalNamespace].eventBus.addListener("sdk-ready", () =>
    fetchUserProfile(store)
  );
};
